export const removeAnchor: (url: string) => string = (url: string): string => {
  if (!url) return '';

  return url.split('#')[0];
};
